import { render, staticRenderFns } from "./PriceOptimizationSelect.vue?vue&type=template&id=ca91cdd4&scoped=true"
import script from "./PriceOptimizationSelect.vue?vue&type=script&lang=js"
export * from "./PriceOptimizationSelect.vue?vue&type=script&lang=js"
import style0 from "./PriceOptimizationSelect.vue?vue&type=style&index=0&id=ca91cdd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca91cdd4",
  null
  
)

export default component.exports
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTooltip,QCardSection,QCard,QPageContainer});
